import { styled } from '@material-ui/core/styles'
import { Lock } from '@material-ui/icons'

export const SessionLock = styled(Lock)({
  color: '#b6bec8'
})
